import { instances } from '@/services/http';
import { useMutation } from '@tanstack/vue-query';
import type { UserDashboardStartUgcResponseType } from '@magma-app/magma-types/user-dashboard/ugc';

export const useStartUgc = () => {
  return useMutation({
    mutationFn: async ({ ugcId }: { ugcId: number }) => {
      const response = await instances.userDashboard.post(
        `ugcs/${ugcId}/start`
      );
      return response.data as UserDashboardStartUgcResponseType;
    },
    // Remove automatic query invalidation to prevent modal closing
    // onSuccess: () => {
    //   queryClient.invalidateQueries({ queryKey: ['ugcs'] });
    // },
  });
};
